import React from 'react';
import Header from './components/Header';
import CourseOverview from './components/CourseOverview';
import Highlights from './components/Highlights';
import WhatYouLearn from './components/WhatYouLearn';
import CourseStructure from './components/CourseStructure';
import Mentor from './components/Mentor';
import Syllabus from './components/Syllabus';
import Pricing from './components/Pricing';
import StudentForm from './components/StudentForm';
import Footer from './components/Footer';

const App = () => (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-gray-50 to-gray-200">
        <nav className="sticky top-0 bg-gradient-to-r from-blue-700 to-purple-700 text-white shadow-lg z-50">
            <div className="container mx-auto flex flex-col sm:flex-row justify-between items-center px-4 py-4">
                <div className="flex items-center gap-4">
                    <img src="/Edusmartup_logo.png" alt="EduSmartUp Logo" className="h-12 w-12 rounded-full shadow-md" />
                    <h1 className="text-2xl sm:text-3xl font-bold tracking-wide">EduSmartUp</h1>
                </div>
                <div className="mt-2 sm:mt-0 text-center sm:text-left">
                    <h2 className="text-lg sm:text-xl font-semibold">Full Stack Development Course</h2>
                </div>
            </div>
        </nav>
        <main className="flex-1">
            <section id="header" className="py-20 bg-gradient-to-r from-purple-700 to-blue-600 text-white">
                <Header />
            </section>
            <section id="course-overview" className="py-16 bg-gray-50">
                <CourseOverview />
            </section>
            <section id="highlights" className="py-16 bg-gray-100">
                <Highlights />
            </section>
            <section id="what-you-learn" className="py-16 bg-gray-50">
                <WhatYouLearn />
            </section>
            <section id="course-structure" className="py-16 bg-gray-100">
                <CourseStructure />
            </section>
            <section id="mentor" className="py-16 bg-gray-50">
                <Mentor />
            </section>
            <section id="syllabus" className="py-16 bg-gray-100">
                <Syllabus />
            </section>
            <section id="pricing" className="py-16 bg-gray-50">
                <Pricing />
            </section>
            <section id="enroll" className="py-16 bg-gray-100">
                <StudentForm />
            </section>
        </main>
        <Footer />
    </div>
);

export default App;
